import React, { useEffect, useState } from "react";
import { REACT_APP_BACKEND_URL } from "../../Utils/Language/urlBase";
import CustomFormDialog from "../CustomFormDialog";

const EditOtherPartyDialog = ({
    isOpen,
    onClose,
    authHeader,
    otherPartyId,
}) => {
    const [otherPartyToEdit, setOtherPartyToEdit] = useState({
        name: "",
        phone: "",
        typeId: 0,
        address: "", // Added address field
        taxNumber: "", // Added taxNumber field
    });
    const [otherPartiesTypes, setOtherPartiesTypes] = useState([]);

    // Fetch Other Party Types
    useEffect(() => {
        const getOtherPartiesTypes = async () => {
            try {
                const response = await fetch(
                    `${REACT_APP_BACKEND_URL}/otherparty/gettypes`,
                    {
                        method: "GET",
                        headers: {
                            Authorization: authHeader,
                            "Content-Type": "application/json",
                        },
                    }
                );
                if (response.ok) {
                    const responseData = await response.json();
                    setOtherPartiesTypes(responseData.otherpartyTypes);
                } else {
                    throw new Error("Failed to fetch other party types");
                }
            } catch (error) {
                console.error(error.message);
            }
        };
        getOtherPartiesTypes();
    }, [authHeader]);

    // Fetch Other Party Details for Editing
    useEffect(() => {
        if (otherPartyId) {
            const fetchOtherPartyDetails = async () => {
                const response = await fetch(
                    `${REACT_APP_BACKEND_URL}/otherparty/${otherPartyId}`,
                    {
                        method: "GET",
                        headers: {
                            Authorization: authHeader,
                            "Content-Type": "application/json",
                        },
                    }
                );
                if (response.ok) {
                    const responseData = await response.json();
                    setOtherPartyToEdit(responseData.otherparty);
                }
            };
            fetchOtherPartyDetails();
        }
    }, [authHeader, otherPartyId]);

    const formFields = [
        {
            name: "name",
            label: "Name",
            type: "text",
            required: true,
            defaultValue: otherPartyToEdit.name || "",
        },
        {
            name: "phone",
            label: "Phone",
            type: "text",
            defaultValue: otherPartyToEdit.phone || "",
        },
        {
            name: "address",
            label: "Address",
            type: "text",
            defaultValue: otherPartyToEdit.address || "",
        },
        {
            name: "taxNumber",
            label: "Tax Number",
            type: "text",
            defaultValue: otherPartyToEdit.taxNumber || "",
        },
        {
            name: "typeId",
            label: "Type",
            type: "select",
            defaultValue: otherPartyToEdit.typeId || "",
            options: otherPartiesTypes.map((type) => ({
                value: type.id,
                label: type.name,
            })),
        },
    ];

    const handleSubmit = async (formData) => {
        const response = await fetch(
            `${REACT_APP_BACKEND_URL}/otherparty/${otherPartyId}`,
            {
                method: "PATCH",
                headers: {
                    Authorization: authHeader,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(formData),
            }
        );
        if (response.ok) {
            onClose();
        }
    };

    return (
        <CustomFormDialog
            title="Edit Other Party"
            fields={formFields}
            open={isOpen}
            onClose={onClose}
            handleSubmitClick={handleSubmit}
        />
    );
};

export default EditOtherPartyDialog;
